import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.permission.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.permission.description',
    defaultMessage: '',
  },
  permissionTitle: {
    id: 'cc4.form.permission.title',
    defaultMessage: 'Sign permission to handle your claim',
  },
  permissionSubTitle: {
    id: 'cc4.form.permission.sub-title',
    defaultMessage: `Draw your signature`,
  },
  permissionDescription: {
    id: 'cc4.form.permission.description',
    defaultMessage: `By signing, you agree to our <tac>Terms and Conditions</tac>, <prices>Pricing List</prices> and the {poa, select, null {} other {<poa>Power of Attorney</poa>}}{ppoa, select, null {} other {<ppoa>, Legal Power of Attorney</ppoa>}}{cpoa, select, null {} other {<cpoa>, Referral to the Mediator</cpoa>}}{aoc, select, null {} other {<aoc>, Assignment of Credit</aoc>}}.`,
  },
  permissionBenefitCancellation: {
    id: 'cc4.form.permission.benefit-paragraph-first',
    defaultMessage:
      'Free cancellation. You can cancel your claim free of charge within 14 days without reason.',
  },
  permissionBenefitNoHassle: {
    id: 'cc4.form.permission.benefit-paragraph-second',
    defaultMessage:
      'No hassle with the airline — we take all the work off your hands.',
  },
  permissionBenefitNoCureNoPay: {
    id: 'cc4.form.permission.benefit-paragraph-third',
    defaultMessage:
      'No cure no pay: pay only 35% upon success (+15% in case we have to start a lawsuit).',
  },
  permissionDescriptionFrenchCourt: {
    id: 'cc4.form.permission.description-french-court',
    defaultMessage: `By signing, you agree to our <tac>Terms and conditions</tac>, <poa>Power of attorney</poa> form and our <ppoa>Legal power of attorney</ppoa> form.`,
  },
  permissionSignature: {
    id: 'cc4.form.permission.signature',
    defaultMessage:
      'Click and draw your signature as it appears in your passport',
  },
  submitContinue: {
    id: 'cc4.form.permission.button.submit-continue',
    defaultMessage: 'Continue',
  },
  submitContinueMobile: {
    id: 'cc4.form.permission.button.mobile-submit-continue',
    defaultMessage: 'Continue',
  }, 
  submitContinueVolRetardeBe: {
    id: 'cc4.form.permission.button.submit-continue-vol-retarde-be',
    defaultMessage: 'Signez et envoyez, payez seulement si gagné',
  },
  permissionBackButton: {
    id: 'cc4.form.permission.button.back',
    defaultMessage: 'Back',
  },
  saveSignatureButton: {
    id: 'cc4.form.permission.save-signature-button',
    defaultMessage: 'Save signature',
  },
  asideText: {
    id: 'cc4.form.permission.aside-text',
    defaultMessage:
      'We need your signature to represent you in front of the airline.',
  },
  dangerMessage: {
    id: 'cc4.form.permission.error-message',
    defaultMessage:
      'Unfortunately, due to an unexpected error, your data could not be saved. Please restart the process on our homepage and provide all the required information again. Our apologies for the inconvenience.',
  },
  permissionDescriptionLawyer: {
    id: 'cc4.form.permission.description-assignment-of-credit-single-passenger',
    defaultMessage:
      'You hereby sign an {aoc, select, null {} other {<aoc>Assignment of Credit</aoc>}} (type of Power of Attorney) by which you transfer your claim (rights) to us. We are the only ones that are allowed to collect the claim, take legal action(s) and be paid. If the claim is awarded, we will pay you according to our <prices>Pricing List</prices> and the <tac>Terms and Conditions</tac>. Be aware: If the airline does pay you directly while we are working on your claim then this payment may be reclaimed by the airline.',
  },
});
